import { render, staticRenderFns } from "./ImageNote.vue?vue&type=template&id=10e4f518&"
import script from "./ImageNote.vue?vue&type=script&lang=js&"
export * from "./ImageNote.vue?vue&type=script&lang=js&"
import style0 from "./ImageNote.vue?vue&type=style&index=0&id=10e4f518&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports